<!--
 * @Description: 运营总览订单占比情况组件
 * @Author: gaohc
 * @Date: 2022-07-13 09:43:52
 * @LastEditTime: 2022-11-04 13:33:01
-->
<template>
  <div class="body">
    <div class="body-header">
      <span style="font-weight: 600; color: #333333">订单占比情况</span>
    </div>
    <div class="body-title">
      <span style="margin-right: 10px">订单数量</span>
      <span v-for="(item, index) in orderCount" :key="index" class="order-count-style">
        {{ item }}
      </span>
    </div>
    <div style="width: 100%; height: 300px" :id="id" ref="echarts"></div>
  </div>
</template>

<script>
import Util from "@/global/Util.js";
export default {
  name: "OrderPieCharts",
  props: ["id", "orderData", "orderCount"],

  mounted() {
    this.drawCharts();
  },

  watch: {
    //子组件监听父组件数据实时更新
    orderData: {
      handler(_newValue, _oldValue) {
        this.drawCharts();
      },
      deep: true,
    }
  },

  methods: {
    drawCharts() {
      let lengendData = this.orderData;
      let myChart = this.echarts.init(document.getElementById(this.id));
      myChart.setOption({
        color: ["#3E7EF5", "#3AC9EA", "#FEB64D", "#FFDB90", "#5BC49F",
          "#F09196", "#80FFA5", "#FE7C4B", "#FF0087"],
        tooltip: { trigger: "item", formatter: "{b} : {c}" },
        legend: {
          type: "scroll",
          orient: "vertical", //图例的布局，水平布局、垂直布局
          icon: "circle",
          itemWidth: 8, //图例宽度
          itemHeight: 8, //图例高度
          padding: 0,
          itemGap: 15, //图例之间的间隙
          top: 20,
          right: 30,
          bottom: 20,
          formatter: function (name) {
            // 获取legend显示内容
            let p = 0;
            let arr = lengendData.map((x) => {
              return x.value;
            });
            for (let i = 0, l = lengendData.length; i < l; i++) {
              if (lengendData[i].name == name) {
                p = Util.getPercentValue(arr, i, 1);
              }
            }
            return `{one|${name}}` + `{two|${p}%}`;
          },
          textStyle: {
            rich: {
              one: {width: 60, color: "#333333", fontSize: 12, align: 'left'},
              two: {width: 50, color: "#333333", fontSize: 12, align: 'left'},
            },
          },
        },
        series: [
          {
            type: "pie",
            radius: ["30%", "60%"],
            center: ["28%", "50%"], //圆的位置
            label: { normal: {show: false} },
            labelLine: {show: false},
            data: this.orderData,
          },
        ],
      });
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
  },
};
</script>

<style  scoped>
.body {
  height: 440px;
  border-radius: 6px;
  border: 1px solid #d7dde5;
}

.body-header {
  display: flex;
  justify-content: space-between;
  height: 46px;
  line-height: 46px;
  padding: 0 20px;
  border-bottom: 1px solid #d7dde5;
}

.body-title {
  text-align: left;
  margin: 29px 20px 25px 20px;
  font-size: 14px;
  font-weight: 500;
  color: #333333;
}

.order-count-style {
  display: inline-block;
  width: 24px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  background: #f7f9fe;
  border-radius: 4px;
  border: 1px solid #d7dde5;
  margin-right: 10px;
  font-size: 21px;
}
</style>



// WEBPACK FOOTER //
// src/components/overview/components/OrderPieCharts.vue